import { useContext, useEffect, useState } from "react";
import { t } from "i18next";
import teamsGreenIcon from "../../assets/images/teams.svg";
import teamsWhiteIcon from "../../assets/images/teams-white.svg";
import { Link, useNavigate } from "react-router-dom";
import 'moment/locale/es';
import { getTeam } from "../../services/team";
import { Team } from "../../interfaces/team";
import { LoadingSpinner } from "../general/loading-spinner";
import { UserContext } from "../../App";

export function TeamsMini() {
    const navigate = useNavigate();

    const { userProfile } = useContext(UserContext);

    const [teams, setTeams] = useState<any[]>([]);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        getTeam()
            .then(response => {
                setTeams(response.data);
                setLoaded(true);
            })
            .catch(error => {
                localStorage.removeItem('token');
                navigate("/");
            });
    }, []);

    return (
        <div className="block block-teams-mini">
            <div className="block-inner">
                <h3 className="block-title">
                    <img src={ teamsGreenIcon } alt={ t("teams")} />
                    { t("teams") }
                </h3>
                <div className="block-content">
                    { !loaded && 
                        <LoadingSpinner />
                    }
                    { loaded &&
                        teams.slice(0, 10).map((team: Team) => {
                            return <div key={ 'team-' + team.id } className="team-tile">
                                    <div className="title">
                                        <Link to={ '/teams/' + team.id + '/view' }  title={ team.name }>
                                            { team.name }
                                        </Link>
                                    </div>
                                    <div className="club">
                                        { team.club_name }
                                    </div>
                                </div>
                        })
                    }
                </div>
                <div className="block-footer">
                    { userProfile.role.filter((r: any) => r.id == 'badminton_administrator').length > 0 &&
                        <Link to="/admin/teams" title={ t("teams") } className="btn btn-primary">
                            <img src={ teamsWhiteIcon } alt={ t("teams")} /> { t("teams") }
                        </Link>
                    }
                    { userProfile.role.filter((r: any) => r.id == 'badminton_manager').length > 0 &&
                        <Link to="/manager/teams" title={ t("teams") } className="btn btn-primary">
                            <img src={ teamsWhiteIcon } alt={ t("teams")} /> { t("teams") }
                        </Link>
                    }
                </div>
            </div>
        </div>
    );
}  
